<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               ref="crud"
               v-model="form"
               :permission="permissionList"
               :page.sync="page"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
    </avue-crud>
  </div>
</template>

<script>
import { getUninterfaceLogList } from "@/api/logs";
import { mapGetters } from "vuex";
import crudmixins from "@/basic-common/mixins/crudmixins.js";
import { removePercent } from "@/util/util";
import { getDictionaries } from '@/basic-common/util/dictionaries.js'

const mixin = new crudmixins({})

export default {
  mixins: [mixin],
  data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        ...this.$store.state.publicOption,
        menuWidth: 260,
        menu: false,
        addBtn: false,
        column: [
          {
            label: "接口名称",
            prop: "interfaceName",
            search: true,
            width: '120',
            overHidden: true
          },
          {
            label: "系统名称",
            prop: "systemId",
            type: "select",
            search: true,
            dicData: [],
            dataType: "string",
            props: {
              label: "systemName",
              value: "id"
            },
            width: '100',
            overHidden: true
          },
          {
            label: "IP地址",
            prop: "ipAddress",
            width: '100',
            search: true,
            overHidden: true
          },
          {
            label: "接口URL",
            prop: "interfaceUrl",
            overHidden: true
          },
          {
            label: '请求方式',
            prop: 'requestMethod',
            overHidden: true,
            width: 90,
            type: 'select',
            dicData: [
              {
                "dictKey": "POST",
                "dictValue": "POST"
              },
              {
                "dictKey": "GET",
                "dictValue": "GET"
              }
            ],
            dataType: 'string',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: "请求参数",
            prop: "requestParams",
            overHidden: true
          },
          {
            label: "返回结果",
            prop: "responseData",
            overHidden: true
          },

          {

            label: "调用结果",
            prop: "requestStatus",
            overHidden: true,
            width: 80,
            type: "radio",
            dicData: [
              {
                "dictKey": '0',
                "dictValue": "失败"
              },
              {
                "dictKey": '1',
                "dictValue": "成功"
              }
            ],
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            search: true,
          },
          {
            label: "调用人",
            prop: "userName",
            width: '100',
            overHidden: true
          },
          {
            label: "调用时间",
            prop: "requestTime",
            overHidden: true
          },
          {
            label: "日志时间",
            prop: "searchDate",
            type: "datetime",
            dataType: 'string',
            search: true,
            hide: true,
            showColumn: false,
            searchValue: "",
            dateDefault: true,
            overHidden: true,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            searchRange: true,
            viewDisplay: false,
          }
        ]
      },
      data: []
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.log_usual_view, false),
        form: {},
        selectionList: [],
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          editBtn: false,
          addBtn: false,
          delBtn: false,
          menuWidth: 120,
          dialogType: 'drawer',
          overHidden: true,
          column: [
            {
              label: "服务id",
              prop: "serviceId",
              search: true,
              overHidden: true
            },
            {
              label: "服务host",
              prop: "serverHost",
              search: true,
              overHidden: true
            },
            {
              label: "服务ip",
              prop: "serverIp",
              overHidden: true
            },
            {
              label: "请求ip",
              prop: "remoteIp",
              overHidden: true
            },
            {
              label: "软件环境",
              prop: "env",
              width: '80',
              overHidden: true
            },
            {
              label: "日志级别",
              prop: "logLevel",
              overHidden: true
            },
            {
              label: "日志id",
              prop: "logId",
              overHidden: true
            },
            {
              label: "请求接口",
              prop: "requestUri",
              overHidden: true
            },
            {
              label: '操作人',
              prop: 'createUserName',
              overHidden: true
            },
            {
              label: "日志时间",
              prop: "createTime",
              width: '180',
              overHidden: true
            },
            {
              label: "用户代理",
              prop: "userAgent",
              span: 24,
              hide: true,
              overHidden: true
            },
            {
              label: "日志数据",
              prop: "logData",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              overHidden: true
            },
            {
              label: "请求数据",
              prop: "params",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              overHidden: true
            },
            {
              label: "查询时间",
              prop: "searchDate",
              type: "datetime",
              dataType: 'string',
              hide: true,
              showColumn: false,
              search: true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              dateDefault: true,
              overHidden: true,
              searchRange: true,
              format: "yyyy-MM-dd HH:mm:ss",
              valueFormat: "yyyy-MM-dd HH:mm:ss",
            }
          ]
        },
        data: []
      };
    }
  },
  async created() {
    const systemList = await getDictionaries("/api/interface/system/list")
    const systemColumn = this.findObject(this.option.column, 'systemId')
    systemColumn.dicData = systemList
  },
  methods: {
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    beforeOpen(done) {
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      // 去除参数%
      params = removePercent(params)
      getUninterfaceLogList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    }
  }
};
</script>

<style>
</style>
